import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getArticles = createAsyncThunk('articles/getArticles',
  async (_, { rejectWithValue, getState }) => {
    try {
      const {
        page, size, order, query, articlesStatus, articlesMarket
      } = getState()?.articlesFilter;
      const { data } = await authGet('/articles', {
        params: {
          size,
          page,
          ...(articlesStatus && { articlesStatus }),
          ...(articlesMarket && { articlesMarket }),
          ...(order && { order }),
          ...(query && { query }),
        }
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getArticles;
